import { roundNumber } from '../../utils/roundNumber.js';
/**
 * Interval timestamp calculation for legacy firmware
 * @function
 * @param {IntervalTimestampCalculationParams} params - The parameters for the calculation.
 * @returns Array of epoch timestamps (seconds)
 */
const calculateIntervalTimestampsLegacy = ({ startTime, elapsedTime, interval, numberOfMeasurementsOccurred, endTime = new Date().getTime() / 1000 }) => {
    const timestamps = [];
    // Detect faulty or empty inlay
    if (interval === 0 || !interval)
        return timestamps;
    if (numberOfMeasurementsOccurred === 0 || !numberOfMeasurementsOccurred)
        return timestamps;
    let correctedElapsedTime, timestampCorrectionFactor;
    // Calculate elapsedTime if label returned faulty elapsedTime of 0 or 1
    if (elapsedTime <= 1) {
        elapsedTime = numberOfMeasurementsOccurred * interval;
        correctedElapsedTime = elapsedTime;
        timestampCorrectionFactor = 1;
    }
    else {
        correctedElapsedTime = endTime - startTime;
        timestampCorrectionFactor = correctedElapsedTime / elapsedTime;
        // Check if timestampCorrectionFactor is reasonable
        // Otherwise set back to 1
        // And try to calculate elapsedTime because it's faulty
        if (Math.abs(timestampCorrectionFactor - 1) > 0.05) {
            timestampCorrectionFactor = 1;
            elapsedTime = numberOfMeasurementsOccurred * interval;
        }
    }
    for (let timeOfDataPoint = 0; timeOfDataPoint <= elapsedTime; timeOfDataPoint = timeOfDataPoint + interval) {
        const timestamp = startTime + timeOfDataPoint * timestampCorrectionFactor;
        timestamps.push(timestamp);
    }
    return timestamps; //.slice(0, payload.numberOfMeasurementsOccurred)
};
/**
 * @typedef {Object} IntervalTimestampsResult
 * @property {number[]} intervalTimestamps - Array of epoch timestamps (seconds).
 * @property {number} preciseInterval - A corrected timestamp value.
 */
/**
 * Interval timestamp calculation for Tapp's firmware
 * @function
 * @param {import('../../types/index.js').IntervalTimestampCalculationParams} params The parameters for the calculation.
 * @returns {IntervalTimestampsResult} Object containing interval timestamps and precise interval.
 */
const calculateIntervalTimestamps = ({ startTime, startDelay = 3, elapsedTime, interval, numberOfMeasurementsOccurred, endTime = new Date().getTime() / 1000 }) => {
    const intervalTimestamps = [];
    // Detect faulty or empty inlay
    if (interval === 0 || !interval)
        return { intervalTimestamps, preciseInterval: interval, preciseStartTime: startTime };
    if (numberOfMeasurementsOccurred === 0 || !numberOfMeasurementsOccurred)
        return { intervalTimestamps, preciseInterval: interval, preciseStartTime: startTime };
    let timeCorrectionFactor = 1;
    const configTime = startTime - startDelay;
    // Calculate timeCorrectionFactor when elapsedTime is higher than 1
    if (elapsedTime > 1) {
        const correctedElapsedTime = endTime - startTime;
        const correctedElapsedTimeFromConfig = correctedElapsedTime + startDelay;
        const elapsedTimeFromConfig = elapsedTime + startDelay;
        timeCorrectionFactor = correctedElapsedTimeFromConfig / elapsedTimeFromConfig;
    }
    // Check if timeCorrectionFactor is reasonable
    // Otherwise set back to 1
    if (timeCorrectionFactor < 0.95 || timeCorrectionFactor > 1.05) {
        timeCorrectionFactor = 1;
    }
    const preciseInterval = interval * timeCorrectionFactor;
    const preciseStartTime = configTime + startDelay * timeCorrectionFactor;
    for (let i = 0; i < numberOfMeasurementsOccurred; i++) {
        const timestamp = preciseStartTime + i * preciseInterval;
        intervalTimestamps.push(roundNumber(timestamp, 3));
    }
    return {
        intervalTimestamps,
        preciseInterval: roundNumber(preciseInterval, 3),
        preciseStartTime: roundNumber(preciseStartTime, 3)
    };
};
export { calculateIntervalTimestampsLegacy, calculateIntervalTimestamps };
